import { Module } from 'vuex';
import { gradesV2Service } from '@/services/grades-v2/grades-v2.service';
import { GradeV2 } from '@/services/grades-v2/grades-v2.types';
import { RootState } from '@/store';
import { formsService } from '@/services/forms/forms.service';

export interface GradeV2State {
  gradeV2: GradeV2;
  gradeV2Loading: boolean;
}

const state: GradeV2State = {
  gradeV2: null,
  gradeV2Loading: false
};

const options: Module<GradeV2State, RootState> = {
  namespaced: true,
  state: () => state,
  actions: {
    initGradeV2({ commit }, gradeV2: GradeV2) {
      commit('gradeV2', gradeV2);
    },
    getGradeV2({ commit, dispatch }, gradeV2Id: number) {
      commit('gradeV2Loading', true);
      return gradesV2Service
        .get(gradeV2Id)
        .then(gradeV2 => gradeV2 && commit('gradeV2', gradeV2))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('gradeV2Loading', false));
    },
    createGradeV2({ commit, dispatch }, gradeV2: GradeV2): Promise<void> {
      commit('gradeV2Loading', true);
      return gradesV2Service
        .create(gradeV2)
        .then(grade => grade && commit('gradeV2', { ...state.gradeV2, ...grade }))
        .then(() => dispatch('alert/pushSuccess', 'Grading V2 créé avec succès !', { root: true }))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('gradeV2Loading', false));
    },
    updateGradeV2({ commit, dispatch, state }, gradeV2: GradeV2): Promise<void> {
      commit('gradeV2Loading', true);
      return gradesV2Service
        .update(state.gradeV2.id, gradeV2)
        .then(gradeV2 => gradeV2 && commit('gradeV2', gradeV2))
        .then(() => dispatch('alert/pushSuccess', 'Grading V2 mis à jour avec succès !', { root: true }))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('gradeV2Loading', false));
    },
    deleteGradeV2({ commit, dispatch }, gradeV2Id: number): Promise<void> {
      commit('gradeV2Loading', true);
      return gradesV2Service
        .delete(gradeV2Id)
        .then(() => commit('gradeV2', null))
        .then(() => dispatch('alert/pushSuccess', 'Grading V2 supprimé avec succès !', { root: true }))
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('gradeV2Loading', false));
    },
    calculNewGrade({ commit, dispatch }, gradeV2: GradeV2): Promise<void> {
      commit('gradeV2Loading', true);
      return gradesV2Service
        .calculNewGrade(gradeV2)
        .then(grade => {
          grade && commit('gradeV2', { ...gradeV2, ...grade });
        })
        .catch(error => error && dispatch('alert/pushError', error, { root: true }))
        .finally(() => commit('gradeV2Loading', false));
    },
    editDescRma({ commit }, value: string) {
      const updatedGradeV2 = {
        ...state.gradeV2,
        desc_rma: value
      };
      commit('gradeV2', updatedGradeV2);
    },
    clearGradeV2({ commit }) {
      commit('gradeV2', null);
    }
  },
  mutations: {
    gradeV2: (state, gradeV2: GradeV2) => (state.gradeV2 = gradeV2),
    gradeV2Loading: (state, loading: boolean) => (state.gradeV2Loading = loading)
  },
  getters: {
    gradeV2Form: state => {
      if (!state.gradeV2) return null;
      return formsService.getGradeV2Form(state.gradeV2);
    }
  }
};

export default options;
